import { createFeatureSelector } from '@ngrx/store';

export const loyaltyIntroductionPagesState = createFeatureSelector<OLO.State, OLO.State.LoyaltyIntroductionPages>('loyaltyIntroductionPages');
